import type { MetricsInfo } from 'owa-calendar-compose-types';

export default function (metricsInfo: MetricsInfo) {
    const qcDurationDict = metricsInfo.quickComposeControlUsageMetrics
        ? metricsInfo.quickComposeControlUsageMetrics.durationDict
        : {};
    const qcUsageDict = metricsInfo.quickComposeControlUsageMetrics
        ? metricsInfo.quickComposeControlUsageMetrics.usageDict
        : {};

    let usageMetrics = {};

    Object.keys(qcDurationDict).forEach(control => {
        let customDataKey = `QC${control}UsageTime`;
        usageMetrics[customDataKey] = qcDurationDict[control];
    });

    Object.keys(qcUsageDict).forEach(control => {
        let customDataKey = `QC${control}UsageCount`;
        usageMetrics[customDataKey] = qcUsageDict[control];
    });

    return usageMetrics;
}
